import { Modal, modalClasses, ModalContent } from "@kaltura/ds-react-components";
import styled from "@emotion/styled";
import { FileRow } from "@kaltura/mediaspace-shared-upload";

export const StyledModalContent = styled(ModalContent)(({ theme }) => ({
    overflow: "auto",
    flex: "1 1 auto",
}));

export const StyledModal = styled(Modal)<{ editSizedModal?: boolean }>(({ theme, editSizedModal = false }) => ({
    [`& .${modalClasses.paper}`]: {
        width: editSizedModal ? "790px" : "664px",
        maxWidth: editSizedModal ? "790px" : "664px",
        maxHeight: "85vh",
        display: "flex",
        flexDirection: "column",
        overflowY: "hidden",
        [theme.breakpoints.down("sm")]: {
            minWidth: "100%",
            width: "100%",
            margin: 0,
            borderRadius: 0,
            height: "100%",
            maxHeight: "100%",
        },
    },
}));

export const StyledFileRow = styled(FileRow)(({ theme }) => ({
    width: "100%",
}));
